import { Stack } from '@mui/material';

import { isAccessStatusPendingApproval, useGetAccessRequest } from '@apono/client-app-sdk';

import { Page } from '@common/ui/Page';
import MessageQpAlert from '@common/ui/MessageQpAlert';
import useRequiredParams from '@common/hooks/use-required-params';

import TaskContent from '@MyTasks/organisms/TaskContent';
import RequestApproval from '@MyTasks/organisms/RequestApproval';

export default function TaskDetailsPage() {
  const { id } = useRequiredParams(['id']);

  const { data, isFetched, error } = useGetAccessRequest(id, 10 * 1000);

  return (
    <Page title={`Request ${id} details`}>
      <Stack direction="column" spacing={3} maxWidth="48rem">
        <MessageQpAlert />
        <TaskContent isFetched={isFetched} error={error} data={data} />
        {data && isAccessStatusPendingApproval(data?.status.status) && <RequestApproval request={data} center />}
      </Stack>
    </Page>
  );
}
